import { Card, CardColor } from "./bipai_card_common";
import PokerTableAssemblyPokerBase from "../../../table/module/poker_table/poker_table_ assembly_poker_base";

const { ccclass, property, menu } = cc._decorator;


@ccclass
@menu('custom/bipai/BiPaiTablePoker')
export default class BiPaiTablePoker extends PokerTableAssemblyPokerBase{
    
    protected calcColorPoint(code: number): { point: number; color: number; } {
        return {point: Card.codeToIndex(code), color: Card.codeToColor(code)}
    }
    protected isRedColor(color: number): boolean {
        return color == CardColor.color_red_heart || color == CardColor.color_square
    }


    onDisable(){
        this.node['_action_callback'] = null
    }
}
